// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmSettingsConnection(Props) {
  let kkm = Props.kkm;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const match$2 = React.useState(function () {
        return kkm.ofd_device_id;
      });
  const setOfdId = match$2[1];
  const ofdId = match$2[0];
  const match$3 = React.useState(function () {
        return "";
      });
  const setOfdToken = match$3[1];
  const ofdToken = match$3[0];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                            label: "ОФД ID",
                            type_: "text",
                            name: "ofd_id",
                            disabled: kkm.state === "linked",
                            required: true,
                            onChange: (function (value) {
                                Curry._1(setOfdId, (function (param) {
                                        return value;
                                      }));
                              }),
                            inputClassName: "text-default-gray safari-disabled-input",
                            value: ofdId
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                            label: "ОФД Токен",
                            type_: "text",
                            name: "ofd_token",
                            required: true,
                            onChange: (function (value) {
                                Curry._1(setOfdToken, (function (param) {
                                        return value;
                                      }));
                              }),
                            className: "mt-5",
                            value: ofdToken
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                            title: "Соединить",
                            onClick: (function (param) {
                                const connectData = {
                                  credentials: {
                                    ofd_device_id: ofdId,
                                    ofd_device_token: ofdToken
                                  }
                                };
                                const __x = Buhta_cabinet__Kassa.KkmManagerService.connect(tenant, kkm.id, connectData);
                                $$Promise.get(__x, (function (result) {
                                        if (result.TAG === /* Ok */0) {
                                          return Curry._1(dispatchToasts, {
                                                      TAG: /* Add */0,
                                                      _0: {
                                                        id: Buhta_core__Toast.generateId(undefined),
                                                        text: "ККМ успешно соединена",
                                                        kind: "success",
                                                        onClick: (function (param) {
                                                            
                                                          })
                                                      }
                                                    });
                                        } else {
                                          return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                        }
                                      }));
                              }),
                            className: "w-full mt-6 py-3"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/tickets-20.svg")
                                  }),
                              JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                    className: "ml-2 grow shrink-0 text-gray-medium",
                                    children: [
                                      "Возникли вопросы? Просто",
                                      JsxRuntime.jsx("a", {
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "inline-block",
                                                  children: "напишите нам"
                                                }),
                                            className: "ml-1",
                                            href: "mailto:hello@buhta.com"
                                          })
                                    ]
                                  })
                            ],
                            className: "flex items-center mt-6"
                          })
                    ],
                    className: "bg-white w-full lg:w-140.5 p-6 lg:p-10 rounded shadow-card"
                  }),
              className: "px-4 py-6 lg:px-0 w-full flex justify-center"
            });
}

const make = KkmSettingsConnection;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
